/* eslint-disable no-unused-vars */
import { ECONTRACT_STATUS, EPARTY_STATUS } from "../../../../enums";
import { IApiResponse } from "../../models";
import { IUserInfoResponseData } from "../user/models";

export enum EContractType {
  MILESTONE_CONTRACT = "MILESTONE_CONTRACT",
  COMPLEX_CONTRACT = "COMPLEX_CONTRACT",
  BROKERAGE_CONTRACT = "BROKERAGE_CONTRACT",
  QUICK_TRANSACTION = "QUICK_TRANSACTION",
  VEHICLES = "VEHICLES",
  DEVICES = "DEVICES",
  FURNITURE = "FURNITURE",
  REAL_ESTATES = "REAL_ESTATES",
  SERVICES = "SERVICES",
  ANIMALS = "ANIMALS",
}
export enum ESenderRole {
  PROVIDER = "PROVIDER",
  CUSTOMER = "CUSTOMER",
  BROKER = "BROKER",
  ADMIN = "ADMIN",
}
export interface ItemDetailsDTO {
  title: string;
  description: string;
  feePayee: EFeePayee;
  inspectionPeriod: number;
  deliveryInDays: number;
  quantity?: number;
  category?: string;
  field?: IFieldDTO[];
  images: string[];
}
export interface IFieldDTO {
  key: string;
  value: string;
}
export enum ECurrency {
  SAR = "SAR",
}
export enum EShipmentType {
  SHIPMENT_COMPANY = "SHIPMENT_COMPANY",
  FACE_TO_FACE = "FACE_TO_FACE",
  VIRTUAL = "VIRTUAL",
  NONE = "NONE",
}

export interface IShipmentDTO {
  number: string;
  provider: string;
  fee: number;
  currency: ECurrency;
  feePayee?: string;
  info?: string;
  type?: EShipmentType;
  courierPhoneNumber?: string;
  trackingCode?: string;
}
export enum EReturnPolicy {
  RETURN_SPECIFICATIONS_VIOLATED = "RETURN_SPECIFICATIONS_VIOLATED",
  RETURN_WITHOUT_REASONS_DURING_EXAMINATION_PERIOD = "RETURN_WITHOUT_REASONS_DURING_EXAMINATION_PERIOD",
  NO_RETURN = "NO_RETURN",
}
export enum EFeePayee {
  PROVIDER = "PROVIDER",
  CUSTOMER = "CUSTOMER",
  BOTH = "BOTH",
}
export interface IReturnItemDTO {
  returnReason?: string | null;
  returnReasonDesc?: string | null;
  images?: string[] | null;
}

export interface Transactions {
  createdAt: Date;
  id: string;
  type: string;
  paymentMethod?: string;
  status?: string;
}

export enum ContractClassification {
  STOCK_CONTRACT = "STOCK_CONTRACT",
  STOCK_CONTRACT_HARAJ = "STOCK_CONTRACT_HARAJ",
  BASIC = "BASIC",
  BASIC_HARAJ = "BASIC_HARAJ",
  BROKER_CONTRACT = "BROKER_CONTRACT",
}

export interface UserProfile {
  id: number;
  userId?: string;
  phoneNumber: string;
  nationalIdVerified: true;
  role?: ESenderRole;
  amount?: number;
  status?: EPARTY_STATUS;
  arbitrator?: boolean;
  isSender?: boolean;
  fee?: number;
  profile: {
    firstName: string;
    lastName: string;
    fullName: string;
    languageCode: string;
    photoUrl: string;
    feedbackOverallRatingScore: number;
  };
}

export type PartiesProfiles = {
  [key in ESenderRole]: Partial<UserProfile>[];
};

export interface IMilestonesPartiesData {
  [key: string]: {
    phoneNumber: string | number;
    role: ESenderRole;
    sudoRole?: string;
    amount: string | number;
  }[];
}

export interface CashOutAmount {
  id: number;
  amountDue: number;
  feePercentage: number;
  fee: number;
  cashOutAmount: number;
}

export interface IContractDetailsResponseData {
  activeChildrenCount?: number;
  contractDefinitionId?: string;
  brokerFee?: number;
  cashOutAmountList?: CashOutAmount[];
  id: string;
  type: EContractType;
  contractClassification: ContractClassification;
  address?: {
    city: string;
    countryCode: string;
    district: string;
    id: number;
    postalCode: string;
    street: string;
  };
  milestones?: IContractDetailsResponseData[];

  shortId: string;
  originalItemPrice: number;

  category?: string;

  senderId: string;
  brokerId: string;
  senderPhoneNumber: string;
  senderRole: ESenderRole;
  isParent?: boolean;
  parentId?: string;

  itemDetail: ItemDetailsDTO;
  itemPrice: number;
  unitPrice?: number;
  fee: number;
  totalAmount: number;
  currency: ECurrency;
  feePayee: EFeePayee;
  deadLine?: string;

  shipment?: IShipmentDTO | null;
  deliveryInDays: number;
  partiesProfiles?: PartiesProfiles;
  parties?: Partial<UserProfile>[];
  returnPolicy: EReturnPolicy;
  inspectionPeriod: number;
  returnFee: number;
  returnFeePayee?: EFeePayee | null;
  transactions: Transactions[];
  receiverId: string;
  receiverPhoneNumber?: string | null;
  receiverRole?: ESenderRole;
  redemptionId: number | null;
  deliveryNotes?: string;

  ReturnItemDTO?: IReturnItemDTO | null;
  returnShipment?: IShipmentDTO | null;

  waffyTermsAccepted: boolean;

  metaData: {
    [key: string]: string | number | boolean;
    sellerRequiresShippingInfo: boolean;
  };

  status: ECONTRACT_STATUS;
  createdAt: Date | string;

  escalations?: IContractEscalationDetails[];
  originalQuantity?: number;
  quantity?: number;

  provider: IUserInfoResponseData;
  customer?: IUserInfoResponseData;

  customerAdditionalInfo: string;
  customerShippingAddress: string;
}
export interface IContractEscalationDetails {
  ticketId: string;
  reason: string;
  message: string;
  userId: string;
  userRole: ESenderRole;
  escalationType: EEscalaionType;
  resolved: boolean;
  createdAt: string;
  resolvedAt: string;
}
export enum EEscalaionType {
  CUSTOMER_DENY_DELIVERY = "CUSTOMER_DENY_DELIVERY",
  PROVIDER_ESCALATE_DELIVERY = "PROVIDER_ESCALATE_DELIVERY",
  CUSTOMER_REJECT_ITEM = "CUSTOMER_REJECT_ITEM",
  PROVIDER_ESCALATE_ITEM = "PROVIDER_ESCALATE_ITEM",
  CUSTOMER_CHECK_ESCALATION = "CUSTOMER_CHECK_ESCALATION",
  PROVIDER_CHECK_ESCALATION = "PROVIDER_CHECK_ESCALATION",
}
export interface IContractDetailsBody {
  id?: string;
  type: EContractType;
  senderRole: ESenderRole;
  itemDetail: Partial<ItemDetailsDTO>;
  itemPrice: number | string;
  currency: ECurrency;
  shipment: {
    type: EShipmentType;
    fee?: number | string;
    currency: ECurrency;
  };
  parties?: {
    sudoRole?: string;
    role: ESenderRole;
    phoneNumber: string | number;
    amount: string | number;
  }[];
  contractClassification: ContractClassification;
  brokerFee?: number | string;
  returnPolicy: EReturnPolicy;
  deliveryInDays?: number;
  returnFee?: number;
  returnFeePayee?: EFeePayee | null;
  receiverId: string | null;
  receiverName: string | null;
  returnItem?: IReturnItemDTO;
  returnShipment?: {
    type: EShipmentType;
    fee: number;
    currency: ECurrency;
  };
  metaData?: {
    [key: string]: string | number | boolean;
  };
  waffyTermsAccepted: boolean;
  interactiveContract?: boolean;
  quantity?: number;
  clientReferenceId?: string;
  enableSubmittedStatus?: boolean;
}

export interface IContractDetailsResponse extends IApiResponse {
  data: IContractDetailsResponseData;
}

export interface IContractActionsResponse extends IApiResponse {
  data: IContractActionsResponseData[];
}

export interface IUpdateContractRequestBody {
  title: string;
  description: string;
  fields?: {
    key: string;
    value: string;
  }[];
  images?: string[];
}

export interface ICategoriesResponse extends IApiResponse {
  data: ICategoriesResponseData;
}

export interface IContractListResponse extends IApiResponse {
  data: IContractDetailsResponseData;
}

export interface ICategoriesResponseData {
  contractCategories: {
    id: string;
    arabicCategory: string;
    category: string;
    createdAt: string;
  }[];
}

export interface IContractDetailsResponseData {
  content: IContractDetailsResponseData[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
}

export interface IContractActionsResponseData {
  action: string;
  actionStatus: string;
  actorId: string;
  actorRole: ESenderRole;
  createdAt: Date;
  to: string;
  from?: string;
}
export interface IPostFeedBackRequest {
  contractId: string;
  shortContractId: string;
  contractTitle: string;
  receiverId?: string;
  contractCustomerId?: string;
  providerId?: string;
  providerRole: string;
  ratingScore: number;
  comment?: string;
}

export interface IContractStatsResponse extends IApiResponse {
  data: IContractStats;
}

export interface IContractStats {
  activeUsersStats: {
    registered: number;
    unRegistered: number;
  };
  paidUsersStats: {
    paid: number;
    unPaid: number;
  };
  paymentStats: {
    amountPaid: number;
    amountUnpaid: number;
  };
}
